import { Box, Button, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import Carousel from "react-material-ui-carousel";
import PetsIcon from "@mui/icons-material/Pets";
import { useBreakpoints } from "../../../../hooks/useBreakpoins";
import { colors } from "../../../../theme/colors";

interface Props {
  list: Banner[];
}

export function Carrousel({ list }: Props) {
  const { isSmalldesktop, isMobile } = useBreakpoints();
  const nav = useNavigate();

  const width = () => {
    if (isMobile) {
      return {
        width: "100%",
        height: 200,
        title: 20,
        subTitle: 10,
        buttonFontSize: 10,
        buttonW: 160,
        buttonH: 35,
        textTopMargim: 5,
        textLmargim: 7,
      };
    }
    if (isSmalldesktop) {
      return {
        width: "100%",
        height: 400,
        title: 40,
        subTitle: 30,
        buttonFontSize: 12,
        buttonW: 190,
        buttonH: 45,
        textTopMargim: 7,
        textLmargim: 10,
      };
    }
    return {
      width: "100%",
      height: 700,
      title: 48,
      subTitle: 20,
      buttonFontSize: 14,
      buttonW: 214,
      buttonH: 50,
      textTopMargim: 10,
      textLmargim: 15,
    };
  };

  return (
    <Box width={width().width} margin={"auto"}>
      <Carousel
        next={() => {
          /* Do stuff */
        }}
        prev={() => {
          /* Do other stuff */
        }}
        autoPlay
        interval={10000}
        animation="slide"
        duration={1000}
        swipe
        navButtonsAlwaysVisible
        navButtonsProps={{ style: { background: colors.purple[500] } }}
        activeIndicatorIconButtonProps={{
          style: {
            marginTop: -80,
            zIndex: 2,
            background: colors.purple[500],
            color: colors.purple[500],
            width: 25,
            borderRadius: 5,
            height: 11,
          },
        }}
        indicatorIconButtonProps={{
          style: { marginTop: -80, zIndex: 2 },
        }}
        NextIcon={<PetsIcon sx={{ transform: "rotate(90deg)" }} />}
        PrevIcon={<PetsIcon sx={{ transform: "rotate(270deg)" }} />}
      >
        {list?.map((item, index) => (
          <Box
            key={index}
            onClick={() => nav(item?.link)}
            sx={{ cursor: "pointer" }}
          >
            <Box
              sx={{
                position: "absolute",
                ml: width().textLmargim,
                mt: width().textTopMargim,
              }}
            >
              <Typography
                fontSize={width().title}
                color={colors.purple[500]}
                fontWeight={700}
              >
                {item?.title}
              </Typography>
              <Typography
                fontSize={width().subTitle}
                fontWeight={600}
                color={"#606060"}
              >
                {item?.subTitle}
              </Typography>
              {Boolean(item?.buttonName) && (
                <Button
                  variant="contained"
                  sx={{
                    width: width().buttonW,
                    height: width().buttonH,
                    mt: 10,
                  }}
                >
                  <Link
                    style={{
                      textDecoration: "none",
                      color: "#FFFFFF",
                      fontWeight: 700,
                      fontSize: width().buttonFontSize,
                    }}
                    to={item?.link}
                    target="_blank"
                  >
                    {item?.buttonName}
                  </Link>
                </Button>
              )}
            </Box>
            <Box
              sx={{ boxShadow: "inset 0px 26px 20px -20px rgba(0,0,0,0.4)" }}
            >
              <Link to={item?.link} target="_blank">
                <img
                  style={{
                    zIndex: -2,
                    position: "relative",
                  }}
                  src={item?.photo}
                  width={width().width}
                  height={width().height}
                  alt={"banner"}
                />
              </Link>
            </Box>
          </Box>
        ))}
      </Carousel>
    </Box>
  );
}
